import { useEffect, useState } from 'react';
import avatarImg from '../../../assets/images/agent2.png';
import userImg from '../../../assets/avatar-2.png';

import { MdKeyboardArrowDown } from 'react-icons/md';
import { ContentWrap, LeadPreviewStyle, UserAsidBar } from './LeadPreviewSection.styles';
import ActivityTab from './activity-tab';
import CommunicationTab from './communication-Tab';
import NotesTab from './notes-tab';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import linkedinService from '../../../services/linkedinService';
import dummyImg from '../../../assets/avatar-2.svg';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import { formatStatus } from '../../../helpers/common.js';
const LeadPreviewSection = () => {
  const [activeTab, setActiveTab] = useState('Activity');

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [leadData, setLeadData] = useState(null);
  const [emailThreads, setEmailThreads] = useState([]);
  const [workspaceMembers, setWorkspaceMembers] = useState([]);

  const [assignedTo, setAssignedTo] = useState(null);
  const [selectedTag, setSelectedTag] = useState('Select Tag');
  const [leadStatus, setLeadStatus] = useState('Select Status');

  // dropdown open/close states
  const [openAssign, setOpenAssign] = useState(false);
  const [openTag, setOpenTag] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  const [page, setPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const { fetch, selectedWorkspace } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    selectedWorkspace: v.selectedWorkspace,
  }));

  const { activity_logs_loading, activity_logs_error, activity_logs_data } = linkedinService.GetAllActivityLogs(
    {
      id,
      page,
      itemsPerPage,
      getAll: true,
    },
    page,
  );

  const activityLogs = activity_logs_data?.data?.items || [];

  // close all dropdowns
  const closeAllDropdowns = () => {
    setOpenAssign(false);
    setOpenTag(false);
    setOpenStatus(false);
  };

  // close on outside-click
  useEffect(() => {
    const handler = e => {
      if (!e.target.closest('.select-box')) {
        closeAllDropdowns();
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  useEffect(() => {
    const fetchLeadData = async () => {
      try {
        const response = await linkedinService.singleLeadData(id);
        if (response?.success && response?.data) {
          setLeadData(response?.data);

          if (response?.data?.userLead?.assignUserId) {
            setAssignedTo(response.data.userLead.assignUserId);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (id) {
      fetchLeadData();
    }
  }, [id]);

  useEffect(() => {
    if (selectedWorkspace?.users) {
      setWorkspaceMembers(selectedWorkspace.users);
    }
  }, [selectedWorkspace]);

  useEffect(() => {
    if (activity_logs_data?.LastActivity) {
      navigate(location.pathname, {
        state: { ...location.state, lastActivity: activity_logs_data.LastActivity },
        replace: true,
      });
    }
  }, [activity_logs_data?.LastActivity]);

  return (
    <LeadPreviewStyle>
      <UserAsidBar>
        <div className="user-info">
          <div className="img-box">
            <img
              src={leadData?.userLead?.profile_photo || dummyImg}
              width="85"
              alt="img"
              onError={e => (e.currentTarget.src = dummyImg)}
            />
          </div>
          <div className="text-box">
            <span className="title">
              {leadData
                ? `${leadData?.userLead?.first_name || ''} ${leadData?.userLead?.last_name || ''}`.trim()
                : 'Name'}
            </span>
            <span className="designation">{leadData?.userLead?.title || ''}</span>
            {/* <span className="new-lead">New Lead</span> */}
          </div>
        </div>

        <div className="detail">
          <ul className="info-list">
            <li>
              <span className="subtitle">Name</span>
              <span className="text">
                {leadData
                  ? `${leadData?.userLead?.first_name || ''} ${leadData?.userLead?.last_name || ''}`.trim()
                  : ''}
              </span>
            </li>
            <li>
              <span className="subtitle">Email</span>
              <span className="text">{leadData?.userLead?.email || ''}</span>
            </li>
            <li>
              <span className="subtitle">Phone</span>
              <span className="text">{leadData?.userLead?.phone || '-'}</span>
            </li>
            <li>
              <span className="subtitle">Company</span>
              <span className="text">{leadData?.userLead?.company_name || '-'}</span>
            </li>
            <li>
              <span className="subtitle">Role</span>
              <span className="text">{leadData?.userLead?.title || '-'}</span>
            </li>
            <li>
              <span className="subtitle">Location</span>
              <span className="text">{leadData?.userLead?.location || '-'}</span>
            </li>
            {/* <li>
              <span className="subtitle">Timezone</span>
              <span className="text">{leadData?.userLead?.timezone || '-'}</span>
            </li> */}
          </ul>
        </div>
        <div className="detail">
          <ul className="info-list">
            <li>
              <span className="subtitle">Assigned To</span>

              <div
                className={`select-box assign-select ${openAssign ? 'open' : ''}`}
                onClick={e => {
                  e.stopPropagation();
                  closeAllDropdowns();
                  setOpenAssign(!openAssign);
                }}>
                <span className="item">
                  {!assignedTo ? (
                    <span>Assign To</span>
                  ) : (
                    <>
                      <div className="img-box">
                        <img src={dummyImg} width="20" alt="" />
                      </div>
                      <span>
                        {workspaceMembers.find(m => m.id === assignedTo)?.fullName ||
                          leadData?.userLead?.assignedto ||
                          'Unknown'}
                      </span>
                    </>
                  )}
                </span>

                <MdKeyboardArrowDown className="arrow" />

                {openAssign && (
                  <ul className="select-drop">
                    {workspaceMembers
                      .filter(member => member.id !== assignedTo)
                      .map(member => (
                        <li
                          key={member.id}
                          onClick={e => {
                            e.stopPropagation();
                            setAssignedTo(member.id);
                            setOpenAssign(false);
                          }}>
                          <div className="img-box">
                            <img src={dummyImg} width="20" alt="" />
                          </div>
                          <span className="text">{member.fullName}</span>
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </li>
            <li>
              <span className="subtitle">Tag</span>

              <div
                className={`select-box tag-select ${openTag ? 'open' : ''}`}
                onClick={e => {
                  e.stopPropagation();
                  closeAllDropdowns();
                  setOpenTag(!openTag);
                }}>
                <span className="item">
                  {leadData?.userLead?.tags?.length ? leadData?.userLead?.tags.join(', ') : '-'}
                </span>

                {/* <MdKeyboardArrowDown className="arrow" />

                {openTag && (
                  <ul className="select-drop">
                    {tagOptions.map((opt, i) => (
                      <li
                        key={i}
                        style={{ backgroundColor: opt.bgcolor }}
                        onClick={e => {
                          e.stopPropagation();
                          setSelectedTag(opt.label);
                          setOpenTag(false);
                        }}>
                        <span className="text" style={{ color: opt.textColor }}>
                          {opt.label}
                        </span>
                      </li>
                    ))}
                  </ul>
                )} */}
              </div>
            </li>
            <li>
              <span className="subtitle">Lead Status</span>

              <div
                className={`select-box status-select ${openStatus ? 'open' : ''}`}
                onClick={e => {
                  e.stopPropagation();
                  closeAllDropdowns();
                  setOpenStatus(!openStatus);
                }}>
                <span className="item"> {formatStatus(leadData?.userLead?.status)}</span>
                {/* <MdKeyboardArrowDown className="arrow" /> */}

                {/* {openStatus && (
                  <ul className="select-drop">
                    {leadStatusOptions.map((opt, i) => (
                      <li
                        key={i}
                        style={{ backgroundColor: opt.bgcolor }}
                        onClick={e => {
                          e.stopPropagation();
                          setLeadStatus(opt.label);
                          setOpenStatus(false);
                        }}>
                        <span className="text" style={{ color: opt.textColor }}>
                          {opt.label}
                        </span>
                      </li>
                    ))}
                  </ul>
                )} */}
              </div>
            </li>
          </ul>
        </div>
      </UserAsidBar>

      <ContentWrap>
        <ul className="tabset-list">
          {[
            'Activity',
            // leadData?.userLead?.emailThreadId && 'Communication',

            //  'Notes'
          ].map(tab => (
            <li key={tab}>
              <button className={`btn-tab ${activeTab === tab ? 'active' : ''}`} onClick={() => setActiveTab(tab)}>
                {tab}
              </button>
            </li>
          ))}
        </ul>

        <div className="tabs-content">
          {activeTab === 'Activity' && (
            <div className="activity-content">
              <ActivityTab activityLogs={activityLogs} loading={activity_logs_loading} error={activity_logs_error} />
            </div>
          )}
          {/* {
            activeTab === 'Communication' && (
              <div className="communication-content">
                <CommunicationTab leadId={id} emailThreadId={leadData?.userLead?.emailThreadId} />
              </div>
            )
          } */}

          {activeTab === 'Notes' && (
            <div className="notes-content">
              <NotesTab />
            </div>
          )}
        </div>
      </ContentWrap>
    </LeadPreviewStyle>
  );
};

export default LeadPreviewSection;
